import { lazy } from 'react'

export const KitMealsV1 = lazy(() => import('./kitV1/KitMealsV1'))
export const KitMealsV2 = lazy(() => import('./kitV2/KitMealsV2'))
